// MUI
import { Stack } from "@mui/material";

// Components
import ShowMessage from "./ShowMessage";
import { DATE_FORMAT } from "@/Constants/date";
import { ILocation } from "@/Common/interfaces/location";

interface IShowRegularInformationProps {
	error?: boolean;
	format?: string;
	createdBy?: string;
	updatedBy?: string;
	createdAt?: string | Date;
	updatedAt?: string | Date;
	location: ILocation;
}

const ShowRegularInformation = (props: IShowRegularInformationProps) => {
	const { error, format, createdBy, updatedBy, createdAt, updatedAt, location } = props;
	return (
		<>
			{createdBy && createdAt && (
				<ShowMessage
					message={`Created by ${createdBy} on`}
					dateToUse={createdAt}
					format={format}
					error={error}
					location={location}
					showIcon={true}
				/>
			)}

			{updatedBy && updatedAt && (
				<Stack display={"flex"} direction={"row"} ml={2.3}>
					<ShowMessage
						message={`Last Modified by ${updatedBy} on`}
						dateToUse={updatedAt}
						format={format}
						error={error}
						location={location}
					/>
				</Stack>
			)}

			{updatedAt && !updatedBy && (
				<ShowMessage
					message={`Last Updated on`}
					dateToUse={updatedAt}
					format={DATE_FORMAT.fullAbbrTime12hPadded}
					error={error}
					location={location}
				/>
			)}
		</>
	);
};

export default ShowRegularInformation;
